<template>
	<div class="optionsTabDiv lcpCard">
		<div class="inner">
			<span class="filterTitle">Tests</span>
			<div class="underline"><div class="underlineColour" :class="hightlightPosition"></div></div>
			<div class="slideWrapper" :class="slide">
				<div class="filterDiv">
					<div class="animated" :class="testStarted ? 'closed' : 'fadeIn'">
						<div class="intro">
							Welcome to the testing area. You will be walked through a series of predetermined tests and will be asked to give ratings
							for each test.
						</div>
						<div class="selectTests" v-if="!testStarted">
							<dropdownInput
								title="Test Sets"
								:options="testConfig.map(i => i.name)"
								placeholder="Select A Test Set"
								:index="0"
								:hideSelected="true"
								:showLabels="false"
								:searchable="false"
								mutationRef=""
								@input="setTestConfig"
							/>
						</div>
						<div class="intro" v-if="currentConfig !== null">The tests are as below:</div>
						<div class="test" v-if="currentConfig !== null">
							<div class="testSummary" v-for="test in testConfig[currentConfig].tests" :key="test.title">
								<div class="testTitle" @click="showDesc(test.title)">{{ test.title }}</div>
								<div class="testDescription animated" :class="visibleDesc === test.title ? 'fadeIn' : 'closed'">
									{{ test.description }}
								</div>
							</div>
							<div class="actions">
								<div class="btn" @click="startTest">Start Tests</div>
							</div>
						</div>
					</div>
					<div v-if="testStarted" class="animated" :class="!testStarted ? 'closed' : 'fadeIn'">
						<tests :config="testConfig[currentConfig].tests" @updateValueFilterElement="updateValueFilterElement" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tests from '@/components/common/uiLayouts/tests.vue';

export default {
    components: {
        tests,
    },
    data () {
        return {
            filterArray: [],
            mainHeight: 0,
            originalColour: '',
            originalRaxis: '',
            originalXaxis: '',
            originalYaxis: '',
            showDimensions: false,
            showFilters: true,
            testStarted: false,
            tests: this.testConfig,
            visibleDesc: '',
            currentConfig: null,
        };
    },
    beforeMount () {
        this.originalXaxis = this.$store.state.chart.xAxisSelection;
        this.originalYaxis = this.$store.state.chart.yAxisSelection;
        this.originalRaxis = this.$store.state.chart.raxisSelection;
        this.originalColour = this.$store.state.chart.colourSelection;
        this.testStarted = false;
    },
    updated () {
        this.$nextTick(() => {
            // Filter reload button boolean to appear when any of the filter options have there reload button visible
            // if (this.sliderBool.indexOf(true) !== -1 || this.catDimBool.indexOf(true) !== -1) {
            //     this.showFilterReset = true;
            // } else {
            //     this.showFilterReset = false;
            // }
            if (!this.showTable && this.showTableClicked) {
                this.showTableClicked = false;
            }
        });
    },
    computed: {
        valueOptions () {
            const ret = [];
            for (const n in this.$store.state.universe.data.valueDimensions) {
                ret.push(this.$store.state.universe.data.valueDimensions[n].name);
            }
            return ret;
        },
        categoryOptions () {
            const ret = [];
            for (const n in this.$store.state.universe.data.categoryDimensions) {
                ret.push(this.$store.state.universe.data.categoryDimensions[n].name);
            }
            return ret;
        },
        hightlightPosition () {
            return this.showFilters ? '' : 'right';
        },
        slide () {
            return this.showFilters ? 'slideLeft' : 'slideRight';
        },
        testConfig () {
            return this.$store.state.user.testConfig;
        },
    },
    methods: {
        showDesc (currentView) {
            this.visibleDesc = currentView;
        },
        show (view) {
            if (view === 'filter') {
                this.showFilters = true;
                this.showDimensions = false;
            }
            if (view === 'dimensions') {
                this.showFilters = false;
                this.showDimensions = true;
            }
        },
        // Show the reload button for the respective index at a specific dimension
        resetButton (index, dimension) {
            if (dimension === 'value') {
                this.$set(this.sliderBool, index, true);
                if (this.sliderResetClicked) {
                    this.$set(this.sliderBool, index, false);
                    this.$set(this.sliderPanelsShow, index, true);
                }
                this.sliderResetClicked = false;
            } else if (dimension === 'category') {
                this.$set(this.catDimBool, index, true);
                if (this.selectAllClicked) {
                    this.$set(this.catDimBool, index, false);
                    this.$set(this.categoryPanelsShow, index, true);
                }
                this.selectAllClicked = false;
            }
        },
        sliderReset (key) {
            if (key === 'dateSlider') {
                this.$refs[key].$refs.slider.setCurrentValue(this.$refs[key].$refs.slider.maximum);
                this.$refs[key].$refs.slider.setIndex(0);
                this.datePanelShow = true;
                this.sliderResetClicked = true;
            } else {
                this.$refs.slider[key].$refs.slider.setCurrentValue(this.$refs.slider[key].max);
                this.$refs.slider[key].$refs.slider.setIndex(0);
                this.sliderResetClicked = true;
            }
        },
        updateValueFilterElement (change) {
            this.$emit('updateValueFilterElement', change);
        },
        setTestConfig (value) {
            const index = this.testConfig.findIndex(z => z.name === value.options);
            if (index > -1) {
				(this.currentConfig = index);
			}
		},
		startTest () {
			this.testStarted = true
			if (this.currentConfig === 2) {
				this.$store.commit('chart/updateTooltipSelection', 'Infastructure');
			} else {
				this.$store.commit('chart/updateTooltipSelection', 'General');
			}
		}
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/all.scss";
.optionsTabDiv {
	overflow: hidden;
	padding: 20px;
	position: relative;
	.filterTitle {
		cursor: pointer;
		float: left;
		font-size: 18px;
	}
	.dimensionsTitle {
		cursor: pointer;
		float: right;
		font-size: 18px;
	}
	.underline {
		background-color: $grey;
		float: left;
		height: 2px;
		margin: 5px 0 0 0;
		position: relative;
		width: 100%;
		.underlineColour {
			background: $LCPMarine;
			height: 3px;
			left: 0;
			position: absolute;
			top: 0px;
			width: 30%;
			@include easeInOut(1s);
			&.right {
				left: 70%;
			}
		}
	}
	.inner {
		overflow: hidden;
		margin-top: 0;
		@include easeInOut(0.5s);
		bottom: 10px;
		left: 20px;
		position: absolute;
		right: 20px;
		top: 10px;
		&.slideUp {
			margin-top: -56px;
			min-height: 570px;
		}
	}
	.slideWrapper {
		float: left;
		width: 210%;
		position: relative;
		left: 0%;
		@include easeInOut(1s);
		margin-top: 20px;
		height: calc(100% - 60px);
		.filterDiv,
		.dimensionsDiv {
			height: 100%;
			position: absolute;
			width: 47.5%;
			.intro {
				margin-bottom: 20px;
			}
			.testSummary {
				border: 2px solid $LCPWatermelon;
				margin-bottom: 5px;
				.testTitle {
					background: $LCPWatermelon;
					color: white;
					cursor: pointer;
					padding: 5px;
				}
				.testDescription {
					padding: 5px;
					transition: height, 0.2s linear;
					&.closed {
						height: 0px;
						padding: 0;
						overflow: hidden;
					}
				}
			}
			.actions {
				margin-top: 20px;
			}
		}
		.dimensionsDiv {
			left: 50%;
		}
		.filterDiv {
			left: 0;
		}
	}
	@media (max-width: 1536px) {
		.slideWrapper {
			margin-top: 10px;
		}
	}
	.slideLeft {
		left: 0%;
	}
	.slideRight {
		left: -105%;
	}
	.closed {
		height: 0;
		overflow: hidden;
	}
}
</style>
